import { render, staticRenderFns } from "./ApprovalFail.vue?vue&type=template&id=62d2234e&scoped=true"
import script from "./ApprovalFail.vue?vue&type=script&lang=js"
export * from "./ApprovalFail.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFail.vue?vue&type=style&index=0&id=62d2234e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2234e",
  null
  
)

export default component.exports